import axios from "axios";

const REST_API_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/sales`;

const TOTAL_BALANCE_SUM_URL = `${process.env.REACT_APP_BACKEND_URL}/api/sales/total-balance`;
const AVERAGE_ORDER_VALUE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/sales/average-order-value`;

const TOTAL_BALANCE_SUM_BY_MONTH_URL = (month, year) =>
  `${TOTAL_BALANCE_SUM_URL}/${month}/${year}`;

export const listSalesRecord = () =>
  axios.get(REST_API_BASE_URL, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const createSalesRecord = (sales) =>
  axios.post(REST_API_BASE_URL, sales, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
      Roles: localStorage.getItem("role"),
    },
  });

export const getTotalBalanceSum = () =>
  axios.get(TOTAL_BALANCE_SUM_URL, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const getAverageOrderValue = () =>
  axios.get(AVERAGE_ORDER_VALUE_URL, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const getSalesSummary = () =>
  axios.get(`${REST_API_BASE_URL}/summary`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const getTotalMonthlySales = (month, year) =>
  axios.get(TOTAL_BALANCE_SUM_BY_MONTH_URL(month, year), {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const updateSalesRecord = (salesId, sales) =>
  axios.put(`${REST_API_BASE_URL}/${salesId}`, sales, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const getSalesRecord = (salesId) =>
  axios.get(`${REST_API_BASE_URL}/${salesId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const deleteSalesRecord = (salesId) =>
  axios.delete(`${REST_API_BASE_URL}/${salesId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const deleteAllSalesRecords = () =>
  axios.delete(`${REST_API_BASE_URL}/deleteAll`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const getRecentTransactions = (page, size) => {
  return axios.get(`${REST_API_BASE_URL}/recent`, {
    params: { page, size },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
};

export const getSalesByCustomerId = (customerId, page, size) => {
  return axios.get(`${REST_API_BASE_URL}/customer/${customerId}`, {
    params: { page, size },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
};

export const getOwingCustomers = () => {
  return axios.get(`${REST_API_BASE_URL}/owing-customers`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
};

/**
 * Fetch top product sales for analytics (used by bar chart).
 * Backend endpoint: GET /api/sales/top-products?limit={n}
 */
export const getTopProductSales = (limit = 5) => {
  return axios.get(`${REST_API_BASE_URL}/top-products`, {
    params: { limit },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
};

/**
 * Fetch daily sales trend (used by LineChart).
 * Backend endpoint: GET /api/sales/trend/daily
 * Returns: [{ date: "YYYY-MM-DD", totalRevenue: number }]
 */
export const getDailySalesTrend = () => {
  return axios.get(`${REST_API_BASE_URL}/trend/daily`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
};

/**
 * Fetch daily gross profit trend (used by GrossProfitChart).
 * Backend endpoint: GET /api/sales/trend/gross-profit/daily
 * Returns: [{ date: "YYYY-MM-DD", totalRevenue: number }] (totalRevenue acts as gross profit)
 */
export const getDailyGrossProfitTrend = () => {
  return axios.get(`${REST_API_BASE_URL}/trend/gross-profit/daily`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
};

/**
 * Fetch average order summary (current and previous month) for analytics KPI.
 * Backend endpoint: GET /api/sales/average-order-summary
 * Returns: { currentAvg: BigDecimal, previousAvg: BigDecimal }
 */
export const getAverageOrderSummary = () =>
  axios.get(`${REST_API_BASE_URL}/average-order-summary`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

/**
 * Fetch total distributed quantity dynamically across all product entries.
 * Backend endpoint: GET /api/sales/total-out-quantity
 * Returns: BigDecimal (sum of all quantities distributed)
 */
export const getTotalOutQuantity = () =>
  axios.get(`${REST_API_BASE_URL}/total-out-quantity`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
